export default "__VITE_ASSET__DoEypNnU__"